import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext(null);

export function AppProvider({ children }) {
    const [userId, setUserId] = useState(null);
    const [isWorker, setIsWorker] = useState(false);
    const [country, setCountry] = useState('ru');

    return (
        <AppContext.Provider value={{ userId, setUserId, isWorker, setIsWorker, country, setCountry }}>
            {children}
        </AppContext.Provider>
    );
}

export function useAppContext() {
    const ctx = useContext(AppContext);
    if (!ctx) throw new Error('useAppContext must be used within AppProvider');
    return ctx;
}

export default AppContext;
